<template>
    <v-card class="cart-item" outlined>
        <div class="d-flex flex-no-wrap justify-space-between">
            <v-avatar
                    class="ma-3"
                    size="100"
                    tile>
                <v-img :src="product.previewImage"></v-img>
            </v-avatar>

            <v-row justify="start">
                <div>
                    <v-card-title
                            class="headline"
                            v-text="product.name">
                    </v-card-title>

                    <v-card-subtitle v-text="product.productSelector.name"></v-card-subtitle>
                </div>
            </v-row>

            <v-row justify="end" align="center">
                <v-card-title class="headline common__price-color">{{ product.price }}€</v-card-title>
            </v-row>
            <v-card-actions class="cart-item__card-actions">
                <v-btn
                        @click="removeFromCart"
                        :icon="true"
                        color="accent-4">
                    <v-icon small>mdi-trash-can-outline</v-icon>
                </v-btn>
            </v-card-actions>
        </div>
    </v-card>
</template>

<script>
    import { EventBus } from '../../main.js';

    export default {
        name: "CartItem",
        props: {
            product: Object
        },
        data() {
            return {

            }
        },
        methods: {
            removeFromCart: function(){
                EventBus.$emit('shop--remove-from-cart', this.product);
            }
        },
        mounted(){

        }
    }
</script>

<style scoped>
    .cart-item {
        margin: 0 0 10px;
        width: 100% !important;
        max-width: 500px !important;
    }
    .cart-item .headline {
        font-size: 16px !important;
        word-break: break-word;
    }
    .cart-item__text-wrapper{ width: 100%; }
    .cart-item__card-actions {
        width: 35px;
        padding: 0;
    }
</style>